export default "https://cdn-static-staging.gokick.com/assets/8a9bc5ae92c259feb7c9591453bfa6ace937db28/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";